import previewPicture from './previewPicture'

const components = [
    previewPicture
]
export default components
